import React, { useState } from 'react';

import classnames from 'classnames/bind';

import Brand from '@PAGES/common/login/components/Brand';
import LoginForm from 'src/view/PAGES/common/login/components/LoginForm';
import PasswordResetForm from 'src/view/PAGES/common/login/components/PasswordResetForm';

import styles from './Login.module.scss';

const cx: CX = classnames.bind(styles);

function LoginPage() {
    const [showPasswordReset, setShowPasswordReset] = useState(false);

    const handleShowPasswordReset = React.useCallback(() => {
        setShowPasswordReset(true);
    }, []);

    const handleBackToLogin = React.useCallback(() => {
        setShowPasswordReset(false);
    }, []);

    return (
        <div className={cx('page')}>
            <div className={cx('brand-wrapper')}>
                <Brand />
            </div>
            <div className={cx('form-wrapper')}>
                <div />

                {showPasswordReset ? (
                    <PasswordResetForm onBack={handleBackToLogin} />
                ) : (
                    <LoginForm onForgotPassword={handleShowPasswordReset} />
                )}

                <div className={cx('terms')}>
                    Apex Digital GmbH
                    {' '}
                    {new Date().getFullYear()}
                    {' '}
                    <a href="https://apexdigital.online">Terms</a>
                    {' '}
                    |
                    {' '}
                    <a href="https://apexdigital.online">Privacy</a>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
